import { useEffect, useState } from "react";
import WorklistCharts from "./WorklistCharts";
import WorklistProgress from "./WorklistProgress";
import WorklistNewChart from "./WorklistNewChart";
import {
  fetchWorklistRecord,
  deleteWorklist,
} from "../../../services/managerWorkListService";
import DeleteWorklistModal from "./DeleteWorklistModal";
import { useNavigate } from "react-router-dom";

const WorklistDetailsHeader = ({
  worklistId,
  query,
  setWorklist,
  masterData,
  onSuccess,
}) => {
  const navigate = useNavigate();
  const [worklistStat, setWorklistStat] = useState(null);
  const [isLoading, setLoadingState] = useState(false);

  useEffect(() => {
    setLoadingState(true);
    fetchWorklistData();
  }, [query]);

  const fetchWorklistData = async () => {
    const res = await fetchWorklistRecord(worklistId);
    setWorklistStat(res);
    setWorklist(res?.worklist_no);
    setLoadingState(false);
  };

  const onDeleteHandler = async () => {
    try {
      const res = await deleteWorklist(worklistId);
      if (res?.isDeleted) {
        navigate("/manager-worklist");
        window.toastr.success(res?.message);
      } else {
        window.toastr.error(res?.message);
      }
    } catch (error) {
      window.toastr.error("Something failed");
    }
  };

  const [showModalBox, setShowModalBox] = useState(false);

  const closeModal = () => {
    setShowModalBox(false);
  };

  return (
    <>
      <div className="col-xl-12 col-lg-12 col-md-12">
        <div className="row gy-5 g-xl-10">
          <div className="col-xl-5">
            <div className="card card-flush mb-6 mb-xl-9 card1 chart_card">
              <WorklistNewChart
                worklistDetail={worklistStat}
                setShowModalBox={setShowModalBox}
                masterData={masterData}
                isLoading={isLoading}
                onSuccess={onSuccess}
              />
            </div>
          </div>
          <WorklistProgress
            worklistDetail={worklistStat}
            isLoading={isLoading}
          />
          <WorklistCharts worklistDetail={worklistStat} isLoading={isLoading} />
        </div>
      </div>
      <DeleteWorklistModal
        onDeleteHandler={onDeleteHandler}
        showModalBox={showModalBox}
        worklistId={worklistStat?.worklist_no}
        closeModal={closeModal}
      />
    </>
  );
};
export default WorklistDetailsHeader;
